<div class="definition-container">
  @if (selectedTab && !drawer?.opened && data.layer !== 'explorer') {
    <button
      (click)="toggleSidePanel()"
      aria-label="open side panel"
      class="sidebar-button button-icon button-primary open-sidepanel"
      role="button"
      [attr.data-testid]="'open side panel'"
    >
      <mds-icon
        [height]="24"
        [key]="icons.RIGHT_PANEL_OPEN"
        [width]="24"
        class="button-icon icon-margin-right"
      ></mds-icon>
    </button>
  }
  @if (selectedTab && selectedTab.name) {
    <div>
      <mds-tab
        (activeTabChange)="activeTabs($event)"
        [activeTab]="selectedTab"
        [tabs]="tabs"
        class="definition-tab"
      ></mds-tab>
      <mat-drawer-container>
        @if (selectedTab && selectedTab.name != 'Profile' && data.layer !== 'explorer') {
          <mat-drawer class="sidepanel" #drawer mode="side" position="end">
            <app-side-panel
              [data]="sidepanelData"
              [selectionText]="'Selection on grid'"
              [info]="productInfo"
              [view]="'sidepanel'"
              (showSidePanel)="toggleSidePanel()"
              [attr.data-testid]="'open side panel'"
            ></app-side-panel>
          </mat-drawer>
        }
        <mat-drawer-content #drawerContent>
          @if (selectedTab) {
            @switch (selectedTab.name) {
              @case ('Description') {
                <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
              }
              @case ('SCIP') {
                <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
              }
              @case ('Company') {
                <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
              }
              @case ('Profile') {
                <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
              }
              @default {
                <app-composer-grid
                  (reloadData)="reloadData()"
                  (selectedRow)="getSelectedRow($event)"
                  [tabData]="selectedTab"
                  (actionToPerform)="updateFloatingAction($event)"
                ></app-composer-grid>
              }
            }
          }
        </mat-drawer-content>
      </mat-drawer-container>
    </div>
  }
  @if (actionsPanelData.actions.length) {
    <app-actions-panel
      class="add-attribute-btn"
      [ngStyle]="{ left: data.layer === 'explorer' ? '75%' : '50%' }"
      [mode]="'floating'"
      [data]="actionsPanelData"
    ></app-actions-panel>
  }
</div>
<ng-template #descriptionTemplate>
  <app-description
    (reloadData)="reloadData()"
    [data]="selectedTab"
    [isDrawerOpen]="drawer?.opened"
    [productImage]="productImage"
    (actionToPerform)="updateFloatingAction($event)"
  ></app-description>
</ng-template>
